<template>
  <div class="recent-keyword-empty">
    <search-recommend-cell-list v-if="recommendCellList.length > 0"
                                :search-keyword="searchKeyword"
                                :recommend-cell-list="recommendCellList"
                                :thumbnail-info="thumbnailInfo" />
    <search-recommend-tag-list v-else
                               :change-keyword="changeKeyword"
                               :search-keyword="searchKeyword"
                               :re-search-by-fixed-keyword-fn="reSearchByFixedKeywordFn"
                               :keyword-list="keywordList"
                               :move-to-recommend-tag-fn="moveToRecommendTagFn" />
  </div>
</template>
<script>
import { getClampText } from '@/common/util/text.utils'
import SearchRecommendCellList from '@/components/search/SearchRecommendCellList'
import SearchRecommendTagList from '@/components/search/SearchRecommendTagList'
export default {
  name: 'SearchEmptyMessage',
  components: {
    SearchRecommendTagList,
    SearchRecommendCellList
  },
  props: {
    recommendCellList: {
      type: Array
    },
    searchKeyword: {
      type: String
    },
    changeKeyword: {
      type: String
    },
    keywordList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    },
    reSearchByFixedKeywordFn: {
      type: Function
    },
    moveToRecommendTagFn: {
      type: Function
    }
  },
  methods: {
    getClampText: getClampText,
    getCellListContainerClassName (thumbnailInfo) {
      return `cell-list responsive cell-${thumbnailInfo.type}`
    }
  }
}
</script>
